"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var settingRow_1 = require("./settingRow");
var mobx_react_1 = require("mobx-react");
var Settings = (function (_super) {
    __extends(Settings, _super);
    function Settings(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (event) {
            var newSettings = _this.state.settings.slice();
            var value = event.currentTarget.value;
            var name = event.currentTarget.name;
            newSettings.forEach(function (setting, index) {
                if (setting.name == name) {
                    switch (setting.type) {
                        case 'select':
                            setting.value = parseInt(value);
                            break;
                        case 'checkbox':
                            setting.value = event.currentTarget.checked;
                            break;
                        case 'multiselect':
                            var values = event.currentTarget.value.map(function (value) { return parseInt(value); });
                            if (name == 'eval_types') {
                                if (values.length === 0) {
                                    values.push(20);
                                }
                            }
                            setting.value = values;
                            break;
                        default:
                            console.error("unknown setting type: " + setting.type);
                    }
                }
            });
            _this.setState({
                settings: newSettings
            });
            var map = {};
            _this.state.settings.forEach(function (setting) {
                map[setting.name] = setting.value;
            });
            _this.props.save(map);
        };
        _this.state = {
            settings: _this.props.settings
        };
        return _this;
    }
    Settings.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        if (nextProps.settings !== this.props.settings) {
            this.setState({
                settings: nextProps.settings
            });
        }
    };
    Settings.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "Settings m-2" },
            React.createElement("div", { className: "header" },
                React.createElement("h3", null, gettext("List settings"))),
            this.state.settings.map(function (setting) { return (React.createElement(settingRow_1.default, { change: _this.onChange, setting: setting })); })));
    };
    Settings = __decorate([
        mobx_react_1.observer
    ], Settings);
    return Settings;
}(React.Component));
exports.default = Settings;
